import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/form';

import { useCommon } from 'hooks/useCommon';
import { API_ROUTES } from 'lib/api-routes';
import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { TUserApiResponse } from 'lib/models/User.model';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';
import { apiInstance } from 'lib/utils/axios';

import Header from '../Header';
import StepHeading from '../StepHeading';
import styles from './Step3.module.scss';

interface Step3Props {
  progress: number;
  touchpointsExist: boolean;
  setFlowState: (flowState: string) => void;
}

export const Step3: React.FC<Step3Props> = ({
  progress,
  touchpointsExist,
  setFlowState,
}) => {
  const { onShare } = useCommon();
  const { updateUserApiResponse } = useAuth();
  const [t] = useTranslation('onboarding.recruiter');

  const handleNext = async () => {
    const flow_state = ONBOARDING_FLOW_STATE.POST_4;
    const recruiter = { flow_state };
    const userResponse = await apiInstance.patch<TUserApiResponse>(
      API_ROUTES.RECRUITER_SIGNUP,
      {
        recruiter,
      }
    );
    updateUserApiResponse(userResponse.data);
  };

  return (
    <>
      <Header
        percentComplete={progress}
        onBack={() => {
          const flow_state = touchpointsExist
            ? ONBOARDING_FLOW_STATE.POST_2
            : ONBOARDING_FLOW_STATE.PRE_COMPLETE;
          setFlowState(flow_state);
        }}
      />
      <div className={styles.stepContent}>
        <StepHeading
          title={t('step-3.header.title')}
          desc={t('step-3.header.desc')}
        />

        <div>
          <Button
            type="button"
            color="primary"
            className={styles.button}
            onClick={() => {
              onShare(
                t('step-3.button.share.text'),
                `${window.location.origin}${PAGE_ROUTES.RECRUITER_SIGN_UP}`,
                {
                  title: t('step-3.button.share.title'),
                  message: t('step-3.button.share.message'),
                }
              );
            }}
            isFullWidth
          >
            {t('step-3.button.title')}
          </Button>
          <Button
            type="button"
            color="secondary"
            className={cn(styles.yesNoButton, styles.button)}
            onClick={handleNext}
            isFullWidth
          >
            {t('next')}
          </Button>
        </div>
      </div>
    </>
  );
};
